<div class="container-fluid">
  <div class="row flex-nowrap full-height">
    <!-- Header con botón hamburguesa -->
    <header class="header borderline-bottom d-flex justify-content-between">
      <div class="logo-header">
        <a [routerLink]="['/home']">
          <img class="logo" src="../../../assets/images/Logo-colorido.png" alt="Imagen de menú" />
        </a>
      </div>
      <div>
        <button class="btn btn-hamburger" (click)="toggleSidebar()">
          <i class="bi bi-list"></i>
        </button>
      </div>
    </header>

    <!-- Sidebar -->
    <div [ngClass]="{ open: sidebarOpen }" class="col-auto col-md-3 col-xl-2 px-sm-2 px-0 sidebar d-md-block">
      <div class="d-flex flex-column align-items-sm-start px-4 pt-2"
        style="overflow-y: auto; height: calc(100vh - 65px);">
        <div class="display-logo">
          <a [routerLink]="['/home']"
            class="d-flex align-items-center pb-3 mb-md-0 me-md-auto text-decoration-none menu-items">
            <img class="logo" src="../../../assets/images/Logo-colorido.png" alt="Imagen de menú" />
          </a>
        </div>
        <div class="row sidebar-options">
            <ul class="nav nav-pills flex-column mb-sm-auto mb-0 align-items-center align-items-sm-start mt-3" id="menu">
                @if (permisionsService.showDashboard) {
                <li class="nav-item" routerLinkActive="active-item" [routerLinkActiveOptions]="{ exact: true }">
                    <a [routerLink]="['/dashboard']" class="nav-link " (click)="headerSidebar()">
                        <i class="fs-5 bi-grid-1x2"></i>
                        <!-- Eliminado d-none para que no desaparezca -->
                        <span class="ms-1 my-1 p-1">Dashboard</span>
                    </a>
                </li>
                }
                @if (permisionsService.showHome) {
                <li class="nav-item" routerLinkActive="active-item" [routerLinkActiveOptions]="{ exact: true }">
                    <a [routerLink]="['/home']" class="nav-link " (click)="headerSidebar()">
                        <i class="fs-5 bi-house-door"></i>
                        <!-- Eliminado d-none para que no desaparezca -->
                        <span class="ms-1 my-1 p-1">Home</span>
                    </a>
                </li>
                }
                @if (permisionsService.showPlans) {
                <li class="nav-item" routerLinkActive="active-item" [routerLinkActiveOptions]="{ exact: true }">
                    <a [routerLink]="['/plans']" class="nav-link " (click)="headerSidebar()">
                        <i class="fs-5 bi-clipboard-check"></i>
                        <!-- Eliminado d-none para que no desaparezca -->
                        <span class="ms-1 my-1 p-1">Plans</span>
                    </a>
                </li>
                }
                @if (permisionsService.showCustomers && getCustomersRoute) {
                <li class="nav-item" routerLinkActive="active-item" [routerLinkActiveOptions]="{ exact: false }">
                    <a [routerLink]="getCustomersRoute" class="nav-link " (click)="headerSidebar()">
                        <i class="fs-5 bi-people"></i>
                        <!-- Eliminado d-none para que no desaparezca -->
                        <span class="ms-1 my-1 p-1">Customers</span>
                    </a>
                </li>
                }
                @if (permisionsService.showDevices) {
                <li class="nav-item" routerLinkActive="active-item" [routerLinkActiveOptions]="{ exact: true }">
                    <a [routerLink]="['/devices']" class="nav-link " (click)="headerSidebar()">
                        <i class="fs-5 bi-phone-landscape"></i>
                        <!-- Eliminado d-none para que no desaparezca -->
                        <span class="ms-1 my-1 p-1">Devices</span>
                    </a>
                </li>
                }
                @if (permisionsService.showDistributors && getDistributorsRoute) {
                <li class="nav-item" routerLinkActive="active-item" [routerLinkActiveOptions]="{ exact: false }">
                    <a [routerLink]="getDistributorsRoute" class="nav-link " (click)="headerSidebar()">
                        <i class="fs-5 bi-people"></i>
                        <span class="ms-1 my-1 p-1">Distributors</span>
                    </a>
                </li>
                }
                @if (permisionsService.showPartners) {
                <li class="nav-item" routerLinkActive="active-item" [routerLinkActiveOptions]="{ exact: false }">
                    <a [routerLink]="['/partners']" class="nav-link " (click)="headerSidebar()">
                        <i class="fs-5 bi-person"></i>
                        <!-- Eliminado d-none para que no desaparezca -->
                        <span class="ms-1 my-1 p-1">Partners</span>
                    </a>
                </li>
                }
                @if (permisionsService.showUserManagement) {
                <li class="nav-item" routerLinkActive="active-item" [routerLinkActiveOptions]="{ exact: false }">
                    <a [routerLink]="['/user-management']" class="nav-link " (click)="headerSidebar()">
                        <i class="fs-5 bi-person-check"></i>
                        <span class="ms-1 my-1 p-1">User Management</span>
                    </a>
                </li>
                }
                @if (permisionsService.showRoleManagement) {
                <li class="nav-item" routerLinkActive="active-item" [routerLinkActiveOptions]="{ exact: false }">
                    <a [routerLink]="['/role-management']" class="nav-link " (click)="headerSidebar()">
                        <i class="fs-5 bi-person-workspace"></i>
                        <span class="ms-1 my-1 p-1">Role Management</span>
                    </a>
                </li>
                }

                @if (permisionsService.showNotifications) {
                <li class="nav-item" routerLinkActive="active-item" [routerLinkActiveOptions]="{ exact: false }">
                    <a [routerLink]="['/notifications']" class="nav-link " (click)="headerSidebar()">
                        <i class="fs-5 bi-bell"></i>
                        <span class="ms-1 my-1 p-1">Notifications</span>
                    </a>
                </li>
                }
                <!--
                @if (permisionsService.showNotifications) {
                <li class="nav-item" routerLinkActive="active-item" [routerLinkActiveOptions]="{ exact: false }">
                  <a [routerLink]="['/simSearch']" class="nav-link " (click)="headerSidebar()">
                    <i class="fs-5 bi-bell"></i>
                    <span class="ms-1 my-1 p-1">Sim Search</span>
                  </a>
                </li>
                }
                -->
                @if (permisionsService.showInventory) {
                <li class="nav-item" routerLinkActive="active-item" [routerLinkActiveOptions]="{ exact: false }">
                    <a [routerLink]="['/inventory']" class="nav-link " (click)="headerSidebar()">
                        <i class="fs-5 bi-box-seam"></i>
                        <span class="ms-1 my-1 p-1">Inventory</span>
                    </a>
                </li>
                }

                @if (permisionsService.showSendSms && canSendSMS) {
                <li class="nav-item" routerLinkActive="active-item" [routerLinkActiveOptions]="{ exact: false }">
                    <a [routerLink]="['/sendSms']" class="nav-link " (click)="headerSidebar()">
                        <i class="fs-5  bi-send"></i>

                        <span class="ms-1 my-1 p-1">Send SMS</span>
                    </a>
                </li>
                }
                @if (permisionsService.showTickets) {
                <li class="nav-item" routerLinkActive="active-item" [routerLinkActiveOptions]="{ exact: false }">
                    <a [routerLink]="['/tickets']" class="nav-link " (click)="headerSidebar()">
                        <i class="fs-5  bi-ticket-perforated"></i>
                        <span class="ms-1 my-1 p-1">Tickets</span>
                    </a>
                </li>
                }
                @if (permisionsService.isAdmin) {
                <li class="nav-item">
                    <a class="nav-link" data-bs-toggle="collapse" href="#ordersCollapse" role="button" aria-expanded="false"
                       aria-controls="ordersCollapse">
                        <i class="bi bi-gear me-2"></i>
                        Settings
                        <i class="bi bi-chevron-down rotate-icon ms-auto"></i>
                    </a>
                    <div class="collapse sub-menu" id="ordersCollapse">
                        <ul class="nav flex-column">
                            @if (permisionsService.isAdmin) {
                            <li class="nav-item sub-item">
                                <a class="nav-link sub-item" routerLinkActive="active-item"
                                   [routerLinkActiveOptions]="{ exact: false }" [routerLink]="['/settings/plan-types']">
                                    <span class="ms-3">Plan Types</span>
                                </a>
                            </li>
                            <li class="nav-item sub-item">
                                <a class="nav-link sub-item" routerLinkActive="active-item"
                                   [routerLinkActiveOptions]="{ exact: false }" [routerLink]="['/settings/threshold']">
                                    <span class="ms-3">Threshold</span>
                                </a>
                            </li>
                            <li class="nav-item sub-item">
                                <a class="nav-link sub-item" routerLinkActive="active-item"
                                   [routerLinkActiveOptions]="{ exact: false }" [routerLink]="['/settings/carrier-api-settings']">
                                    <span class="ms-3">Carrier API Settings</span>
                                </a>
                            </li>
                            }
                            <!-- <li class="nav-item">
                                <a class="nav-link sub-item" href="#"><span class="ms-3">Threshold</span></a>
                            </li> 
                            -->
                        </ul>
                    </div>
                </li>
                }

            </ul>
        </div>
      </div>
      <!-- Dropdown del usuario -->
      <div class="row dropdown-sidebar borderline-top">
          <!--
          <div class="user-info user-name">User Name</div>
          -->
          <div class="dropdown pb-6 col-12">
              <a href="#" class="d-flex align-items-center text-white text-decoration-none dropdown-toggle"
                 id="dropdownUser1" data-bs-toggle="dropdown" aria-expanded="false">
                  <a class="nav-link ">
                      <i class="fs-3 bi-person-circle"></i>
                      <span class="mx-1 user">Options</span>
                      <i class="fs-6 bi-caret-down-fill"></i>
                  </a>
              </a>
              <ul class="dropdown-menu dropdown-menu-dark text-small shadow">
                  <!-- <li *ngIf="permisionsService.showCustomers" routerLinkActive="active-item"
                     [routerLinkActiveOptions]="{exact: false}"><a class="dropdown-item" href="#" data-bs-toggle="modal"
                                                                   data-bs-target="#configurationsModal"(click)="openConfigurations()">Configurations</a></li> -->
                  <li>
                      <a class="dropdown-item" href="#" (click)="logout()">Sign out</a>
                  </li>
              </ul>
          </div>
          <div class="user-info user-login">{{currentUserDisplayName}}</div>
      </div>
    </div>

    <!-- Contenido principal -->
    <div class="col py-3 overflow-auto main-content">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>

<!-- Incluir el componente del modal -->
<app-configurations-customer></app-configurations-customer>
